//state
export var provinciaState = {
  provincias: [],
  provincia: {},
  status_provincia: ""
};

//getters
export var provinciaGetters = {
  //funciones para optener informacion del state
  getProvincias: state => state.provincias
};

//actions
export var provinciaActions = {
  async getProvincias({ commit }) {
    commit("provincia_request");
    await this._vm.$http
      .get("/apache/rest_api/res.country.state", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: '["id","name", "code",("country_id", ["id", "name"])]'
        },
        params: {
          limit: 80
        }
      })
      .then(res => {
        var provincias = res.data;
        commit("provincia_success", provincias);
        return res;
      })
      .catch(err => {
        commit("provincia_error");
        return err;
      });
  },
  async newProvincia({ commit, state }, provincia) {
    commit("codPostal_request");
    var { name, code_state, country_id, selectedCountry } = provincia;
    var formData = new FormData();
    //{name: "test", city_id: "test", city_name: "test", lng: "10", lat: "12", state_id: 448}
    var newProvincia = `{'name':'${name}','code': '${code_state}','country_id':'${country_id}'}`;
    formData.append("data", newProvincia);
    await this._vm.$http
      .post("/apache/rest_api/res.country.state", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          provincia = {
            ...provincia,
            id: res.data.id,
            country_id: selectedCountry,
            code: code_state
          };
          var provincias = state.provincias;
          provincias.push(provincia);
          commit("provincia_success", provincias);
          return provincias;
        } else {
          commit("provincia_error");
        }
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async editProvincia({ commit, state }, provincia) {
    commit("codPostal_request");
    var { id, name, code_state, country_id, selectedCountry } = provincia;
    var formData = new FormData();
    //{name: "test", city_id: "test", city_name: "test", lng: "10", lat: "12", state_id: 448}
    var newProvincia = `{'name':'${name}','code': '${code_state}','country_id':'${country_id}'}`;
    formData.append("data", newProvincia);
    await this._vm.$http
      .put("/apache/rest_api/res.country.state", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          provincia = {
            ...provincia,
            id: res.data.id,
            country_id: selectedCountry,
            code: code_state
          };
          var provincias = state.provincias;
          var index;
          for (var i = 0; i < provincias.length; i++) {
            if (provincias[i].id == id) {
              index = i;
              provincias[i] = provincias;
              break;
            }
          }
          provincias.splice(index, 1);
          provincias.splice(index, 0, provincia);
          commit("provincia_success", provincias);
          return provincias;
        } else {
          commit("provincia_error");
        }
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async deleteProvinciaAction({ commit, state }, id) {
    commit("provincia_request");
    try {
      await this._vm.$http
        .delete(`/apache/rest_api/res.country.state/${id}`, {
          headers: {
            "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var index;
            var provincias = state.provincias;
            for (var i = 0; i < provincias.length; i++) {
              if (provincias[i].id == id) {
                index = i;
                break;
              }
            }
            provincias.splice(index, 1);
            commit("provincia_success", provincias);

            return provincias;
          } else {
            commit("provincia_error");
          }
        })
        .catch(err => {
          commit("provincia_error");
          return err;
        });
    } catch (error) {
      console.log(error);
    }
  },
  async deleteProvinciaUtility({ commit, state }, id) {
    commit("provincia_request");
    var index;
    var provincias = state.provincias;
    for (var i = 0; i < provincias.length; i++) {
      if (provincias[i].id == id) {
        index = i;
        break;
      }
    }
    provincias.splice(index, 1);
    commit("provincia_success", provincias);

    return provincias;
  }
};

//mutations

export var provinciaMutations = {
  provincia_request(state) {
    state.status_provincia = "loading";
  },
  provincia_success(state, payload) {
    state.status_provincia = "success";
    state.provincias = payload;
    console.log(payload);
  },
  provincia_error(state) {
    state.status_provincia = "error";
  }
};
